import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';
import LinkWrapper from 'pricing-pages-ui-components/components/LinkWrapper';
import { TRACKING_SOURCES, trackClickedLink, trackTooltipInteraction } from '../../../utils/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HUBSPOT_CREDITS_RATE_SHEET_URL = 'https://legal.hubspot.com/hubspot-product-and-services-catalog#HubSpotCreditsRateSheet';
export function HubSpotCreditsWithTooltip({
  count
}) {
  const handleLearnMoreClick = () => {
    trackClickedLink({
      name: 'learn-more-hubspot-credits-link',
      type: 'internal',
      url: HUBSPOT_CREDITS_RATE_SHEET_URL,
      trackingSource: TRACKING_SOURCES.MERCH_CARD
    });
  };
  const learnMoreLink = /*#__PURE__*/_jsx(LinkWrapper, {
    href: HUBSPOT_CREDITS_RATE_SHEET_URL,
    onClick: handleLearnMoreClick,
    external: true,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "publicPricingPage.merchCard.credits.hubspotCreditsCta"
    })
  });
  return /*#__PURE__*/_jsx(Tooltip, {
    placement: "bottom",
    maxInlineSize: "315px",
    onOpenChange: e => {
      if (e.currentTarget.value) {
        trackTooltipInteraction({
          action: 'hovered',
          name: 'included-hubspot-credits-tooltip',
          value: `${count} HubSpot Credits`,
          trackingSource: TRACKING_SOURCES.MERCH_CARD
        });
      }
    },
    headingText: /*#__PURE__*/_jsx(Text, {
      typography: "heading-300",
      color: "text-core-on-fill-default",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.merchCard.credits.hubspotCreditsTooltipHeading"
      })
    }),
    title: /*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(Text, {
        typography: "body-100",
        color: "text-core-on-fill-default",
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "publicPricingPage.merchCard.credits.hubspotCreditsTooltipText",
          options: {
            learnMoreLink
          }
        })
      })
    }),
    children: /*#__PURE__*/_jsx(View, {
      cursor: "help",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "100",
        children: [/*#__PURE__*/_jsx(Text, {
          typography: "body-100",
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "publicPricingPage.merchCard.credits.hubspotCredits",
            options: {
              count: count.toLocaleString()
            }
          })
        }), /*#__PURE__*/_jsx(InfoIcon, {
          color: "icon-core-subtle"
        })]
      })
    })
  });
}